// extracted by mini-css-extract-plugin
export default {"CustomTermsPage":"NWpChvT--lNoofOH-lj03Q=="};